import React from 'react';
import { AppNavigator } from 'src/app/AppNavigator';
import { AppState } from 'src/AppState';
import { reportError } from 'src/easyclaim.app.libs/reportError';

export interface IAutoMoveNextFeatureProps {
	appState: AppState;
	appNavigator: AppNavigator;
}

export default function AutoMoveNextFeature(props: IAutoMoveNextFeatureProps) {
	const canAutoMoveNext = (appState: AppState) => {
		const currentStateScreenRenderer = appState.appService.getCurrentStateScreenRenderer();

		if (currentStateScreenRenderer) {
			const allowAutoMoveNext = !!appState.easyClaimCase?._configuration?.allowAutoMoveNext;
			const { canMoveNext, hasAnyWarnings, blockAutoMoveNext } = currentStateScreenRenderer;

			if (!!blockAutoMoveNext === false && allowAutoMoveNext) {
				return (
					typeof canMoveNext === 'function' &&
					canMoveNext(appState) &&
					(!!hasAnyWarnings === false ||
						(typeof hasAnyWarnings === 'function' && !hasAnyWarnings(appState)))
				);
			}
		}

		return false;
	};

	React.useEffect(() => {
		if (canAutoMoveNext(props.appState)) {
			props.appNavigator.onNext().catch((error) => {
				reportError(error, { context: 'AutoMoveNextFeature.onNext' });
			});
		}
	}, [
		props.appState.vehicleImageFront?.selectState,
		props.appState.vehicleImageFrontLeft?.selectState,
		props.appState.vehicleImageFrontRight?.selectState,
		props.appState.vehicleImageLeft?.selectState,
		props.appState.vehicleImageRear?.selectState,
		props.appState.vehicleImageRearLeft?.selectState,
		props.appState.vehicleImageRearRight?.selectState,
		props.appState.vehicleImageRight?.selectState,
		props.appState.registrationDocument?.selectState,
		props.appState.registrationDocument2?.selectState,
		// props.appState.dashboardImage?.selectState,
		//for dashboard mileage screen we should always check whole screen component completion state so checking state in isOdometerAndMileageScreenCompleated
		props.appState.isOdometerAndMileageScreenCompleated,
		props.appState.vinImage?.selectState,
		props.appState.overallDashboardImage?.selectState,
		props.appState.windshieldImage?.selectState,
	]);

	return <></>;
}
